var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3063 16.6562C12.3293 16.6861 12.3587 16.7103 12.3923 16.7269C12.4258 16.7435 12.4627 16.7522 12.5 16.7522C12.5373 16.7522 12.5742 16.7435 12.6077 16.7269C12.6413 16.7103 12.6707 16.6861 12.6937 16.6562L16.1376 12.2281C16.2636 12.0656 16.1499 11.825 15.9439 11.825H13.6654V1.25C13.6654 1.1125 13.5547 1 13.4194 1H11.5745C11.4392 1 11.3285 1.1125 11.3285 1.25V11.8219H9.05615C8.85013 11.8219 8.73636 12.0625 8.86243 12.225L12.3063 16.6562ZM23.754 15.5625H21.9091C21.7738 15.5625 21.6631 15.675 21.6631 15.8125V20.625H3.3369V15.8125C3.3369 15.675 3.2262 15.5625 3.09091 15.5625H1.24599C1.1107 15.5625 1 15.675 1 15.8125V22C1 22.5531 1.43971 23 1.98396 23H23.016C23.5603 23 24 22.5531 24 22V15.8125C24 15.675 23.8893 15.5625 23.754 15.5625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.facfb78b.svg";
export { ForwardRef as ReactComponent };